import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { PersistentNotificationStack } from '@/components/notifications/PersistentNotificationStack';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { TooltipProvider } from '@/components/ui/tooltip';
import { BreadcrumbsProvider } from '@/context/breadcrumbs';
import { useNotificationsRealtime } from '@/services';

import { AppBar } from './AppBar';
import { Sidebar, SidebarNav } from './Sidebar';
import { useNotificationEffects } from './use-notification-effects';
import { useSeenPath } from './use-seen-path';

export function AdminLayout() {
  const [navOpen, setNavOpen] = useState(false);
  useNotificationsRealtime();
  useNotificationEffects();
  useSeenPath();

  return (
    <BreadcrumbsProvider>
      <TooltipProvider delayDuration={200}>
        <div className="flex min-h-screen bg-muted/40">
          <Sidebar />
          <Sheet open={navOpen} onOpenChange={setNavOpen}>
            <SheetContent side="left" className="border-r">
              <SidebarNav onNavigate={() => setNavOpen(false)} />
            </SheetContent>
          </Sheet>
          <main className="flex-1 min-w-0 overflow-auto">
            <AppBar onOpenNav={() => setNavOpen(true)} />
            <div className="mx-auto max-w-[1400px]">
              <Suspense fallback={<LoadingSpinner />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
        <Toaster
          theme="system"
          position="bottom-right"
          visibleToasts={3}
          toastOptions={{
            classNames: {
              toast: 'group rounded-xl border bg-card text-card-foreground shadow-lg backdrop-blur',
              title: 'text-sm font-medium',
              description: 'text-xs text-muted-foreground',
            },
          }}
        />
        <PersistentNotificationStack />
      </TooltipProvider>
    </BreadcrumbsProvider>
  );
}
